/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetTotalCountOpenUrlaubsantraege$Json$Params {

/**
 * Name der Units optional
 */
  units?: Array<string>;
}

export function getTotalCountOpenUrlaubsantraege$Json(http: HttpClient, rootUrl: string, params?: GetTotalCountOpenUrlaubsantraege$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, getTotalCountOpenUrlaubsantraege$Json.PATH, 'get');
  if (params) {
    rb.query('units', params.units, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

getTotalCountOpenUrlaubsantraege$Json.PATH = '/v1/urlaubsantraege/open';
